import Vue from 'vue';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import SvgVue from 'svg-vue';
import iframeRoutes from './components/map/iframe/router';

import en from "../../lang/en.json";
import nl from "../../lang/nl.json";
import de from "../../lang/de.json";
import es from "../../lang/es.json";
import fr from "../../lang/fr.json";
import pt from "../../lang/pt.json";
import gr from "../../lang/gr.json";

Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(SvgVue);

Vue.component(
    'image_slider',
    require('./components/elements/image_slider.vue').default
)

document.addEventListener('DOMContentLoaded', () => {
    const i18n = new VueI18n({
        locale: document.documentElement.lang,
        fallbackLocale: process.env.DEFAULT_LANGUAGE,
        seo: true,
        messages: { en, nl, es, pt, fr, de, gr }
    });

    Vue.prototype.$appName = process.env.APP_NAME;
    Vue.prototype.$main_color = getComputedStyle(document.body).getPropertyValue("--main_color");
    Vue.prototype.$main_color_darkmode = getComputedStyle(document.body).getPropertyValue("--dark-main_color");
    Vue.prototype.$main_color_bright = getComputedStyle(document.body).getPropertyValue("--main_color_bright");
    Vue.prototype.$main_color_brighter = getComputedStyle(document.body).getPropertyValue("--main_color_brighter");
    Vue.prototype.$sub_color = getComputedStyle(document.body).getPropertyValue("--sub_color");
    Vue.prototype.$third_color = getComputedStyle(document.body).getPropertyValue("--third_color");
    Vue.prototype.$dark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    Vue.prototype.$hostName = window.location.host;
    Vue.prototype.$baseUrl = window.location.protocol + "//" + window.location.host;
    Vue.prototype.$homeUrl = document.documentElement.getAttribute('default_lang') == document.documentElement.lang
        ? Vue.prototype.$baseUrl
        : window.location.protocol + "//" + window.location.host + "/" + document.documentElement.lang;
    Vue.prototype.$termsUrl = Vue.prototype.$homeUrl + "/termsandconditions";
    Vue.prototype.$path = window.location.pathname + window.location.search + window.location.hash;
    Vue.prototype.$BMB_API = process.env.MIX_APP_LOCAL ? 'https://boostmybookings.test/' : 'https://boostmybookings.com/';
    Vue.prototype.$clientID = window.clientID;

    const router = new VueRouter({
        mode: 'history',
        base: '/api/iframe/map/',
        routes: iframeRoutes,
    });

    new Vue({
        el: '#iframe-app',
        router,
        i18n,
    });
});